import React from 'react';
import { UsersList} from './components';

const User = () => {
  return <UsersList />;
};

export default User;
